import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCreditCardYes({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.95 1.2c.97 0 1.75.78 1.75 1.75v3.18a5.78 5.78 0 00-5.14.37H2.7v3.45c0 .12.08.22.2.24l.05.01h2.9c-.1.42-.15.85-.15 1.3v.2H2.95c-.92 0-1.67-.7-1.74-1.6l-.01-.15v-7c0-.97.78-1.75 1.75-1.75zm0 1.5h-9a.25.25 0 00-.25.25V4.3h9.5V2.95a.25.25 0 00-.2-.24l-.05-.01zM11.5 7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm1.39 2.99l-1.77 1.77-.91-.9a.65.65 0 10-.92.92l1.37 1.36c.25.26.66.26.92 0l2.23-2.23a.65.65 0 10-.92-.92z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCreditCardYes.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCreditCardYes.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicCreditCardYes svgRef={ref} {...props} />
));
export default ForwardRef;
